import { useMutation } from "@tanstack/react-query";
import { ExportAiUsagePayload, exportAiUsage } from "Infrastructure/Api/ApiCustom";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export function useExportAiUsageMutation() {
	const showSnackbar = useSnackbar();
	const { t } = useResource();

	return useMutation({
		mutationFn: exportAiUsage,
		onSuccess: (blob: Blob, payload: ExportAiUsagePayload) => {
			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = `ai_usage_${payload.year}.xlsx`;
			link.click();
			URL.revokeObjectURL(link.href);
		},
		onError: () => {
			showSnackbar(t(Resources.Errors.Error500), "error");
		},
	});
}
